import {
  fetchAllReasonsforLTL,
  createReasonForLTL,
  updateReasonForLTL,
} from '@api/appFlowConfig';

const getKeyMappingReasonSingle = (masterData) => {
  return (
    masterData.ops_dashboard_config?.config?.ltl_ndr_reason_config
      ?.csv_field_list || []
  );
};

const reasonFormItemLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

const viewControl = {
  pageTitle: 'Setup',
  buckets: ['ltlNDRMaster'],
  globalActions: [],
  addOptions: [
    {
      key: 'add_single',
      title: 'Single',
      action: 'add',
      type: 'single',
    },
  ],
  id: 'reason_id',
  fetchData: fetchAllReasonsforLTL,
  onSingleAdd: createReasonForLTL,
  add: {
    sampleUrl: undefined,
    downloadSampleCsvFromApiCall: false,
    downloadSampleCsv: null,
    title: 'Add Reason',
  },
  edit: {
    title: 'Edit Reason',
    okText: 'Update',
  },
  warningMsg: 'No Reason to upload',
  successMsg: 'Uploaded Successfully',
  updateMsg: 'Updated Successfully',
  modalHeading: 'Upload Reason',
  singleUploadMapping: getKeyMappingReasonSingle,
  onSingleUpdate: updateReasonForLTL,
  formItemLayout: reasonFormItemLayout,
};

const buckets = {
  ltlNDRMaster: {
    name: 'Reasons',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
